import { AdvancedSearchFormModel } from "../../search/models/advanced-search-form";
import { AppSettings } from "../../app-settings";
import { backboneCollectionProperties } from "../../decorators/backbone-properties";

@backboneCollectionProperties({
    model: AdvancedSearchFormModel
})
export class AdvancedSearchFormsCollection extends Backbone.Collection<AdvancedSearchFormModel> {
    constructor(options?) {
        super(options);
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/collections/advanced-search-forms.ts